import React, { useContext } from 'react';
import PropTypes, { string } from 'prop-types';
import { Route, Switch } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Error } from './pages';
import './styles/app.scss';
import { getRoutes } from './routes';

export const App = ({ recaptchaKey }) => {

  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent);
  const { channel } = useContext(ExperienceContext);
  return (
    <Switch>
      <Route exact path={routes.exerciseMyPrivacyRights.path}>
        <routes.exerciseMyPrivacyRights.component recaptchaKey={recaptchaKey} />
      </Route>
      <Route path={routes.californiaPrivacyRights.path}>
        <routes.californiaPrivacyRights.component />
      </Route>
      <Route path={routes.privacySecurity.path}>
        <routes.privacySecurity.component />
      </Route>
      <Route exact path={routes.exerciseMyPrivacyRightsOld.path}>
        <routes.exerciseMyPrivacyRightsOld.component recaptchaKey={recaptchaKey} />
      </Route>
      <Route path={routes.californiaPrivacyRightsOld.path}>
        <routes.californiaPrivacyRightsOld.component />
      </Route>
      <Route path={routes.privacySecurityOld.path}>
        <routes.privacySecurityOld.component />
      </Route>
      <Route path="/error">
        <Error />
      </Route>
      <Route>
        <Error />
      </Route>
    </Switch>
  );
};

App.propTypes = {
  recaptchaKey: string
};

App.defaultProps = {
  recaptchaKey: ''
};
